import DemoWizardWindowDescription from './DemoWizardWindowDescription';

// The multi-step demo in the compact centered modal, which a window description asks for with `compact = true`: its
// pages show as a strip across the top instead of the rail on the left. The wizard works on a copy of a description's
// own fields ({ ...windowDescription }), so the demo's fields are spread in here; a class extending it would lose the
// inherited ones, its title among them.
const DemoCompactWizardWindowDescription = { ...DemoWizardWindowDescription, compact: true };

export default DemoCompactWizardWindowDescription;
